import constants from '#packages/constants';
import React, { type MouseEvent } from 'react';
import Anchor from './StageAnchorHandle';
import * as util from '#packages/util';
import { withRestrictions } from '#packages/editorRestrictions';
import styles from './StageAnchorsContainer.scss';
import type { StateMapperArgs } from 'types/redux';
import type { CompRef } from 'types/documentServices';
import type { EditorAPI } from '#packages/editorAPI';

interface StageAnchorsContainerStateProps {
  anchors: CompRef[];
  isMobile: boolean;
}

interface StageAnchorsContainerOwnProps {
  onContextMenu: (ev: MouseEvent) => void;
}

interface StageAnchorsContainerProps
  extends StageAnchorsContainerStateProps,
    StageAnchorsContainerOwnProps {}

const StageAnchorsContainer: React.FC<StageAnchorsContainerProps> = ({
  anchors,
  isMobile,
  onContextMenu,
}) => {
  return (
    <div
      className={util.cx(styles.anchorsContainer, {
        [styles.mobileEditor]: isMobile,
      })}
    >
      {anchors.map((anchorRef, anchorRefIndex) => (
        <Anchor
          key={`anchor${anchorRefIndex}`}
          compRef={anchorRef}
          onContextMenu={onContextMenu}
        />
      ))}
    </div>
  );
};

StageAnchorsContainer.displayName = 'stageComps';

const getAnchors = (editorAPI: EditorAPI) => {
  const pageRef = editorAPI.dsRead.pages.getReference(
    editorAPI.dsRead.pages.getFocusedPageId(),
  );
  return editorAPI.components.get.byType(constants.COMP_TYPES.ANCHOR, pageRef);
};

const mapStateToProps = ({
  editorAPI,
}: StateMapperArgs): StageAnchorsContainerStateProps => {
  const isMobile = editorAPI.isMobileEditor();

  const anchors = getAnchors(editorAPI);

  return { isMobile, anchors };
};

export default withRestrictions('rEditor_anchors-container')(
  util.hoc.connect(
    util.hoc.STORES.EDITOR_API,
    mapStateToProps,
  )(StageAnchorsContainer),
);
